'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { type AvatarItem, AvatarStack } from '~/components/AvatarStack';
import { Link } from '~/components/Link';
import { useIsDesktop } from '~/hooks/useIsDesktop';
import styles from './TripCuratorsSection.module.css';
type TripCuratorsSectionProps = {
  curators: ReadonlyArray<AvatarItem>;
};
export function TripCuratorsSection(t0) {
  const $ = _c(23);
  const {
    curators
  } = t0;
  const t = useTranslations("journey");
  const commonT = useTranslations("common");
  const isDesktop = useIsDesktop();
  if (curators.length === 0) {
    return null;
  }
  const t1 = isDesktop ? 138 : 59;
  const t2 = isDesktop ? 96 : 40;
  let t3;
  if ($[0] !== curators || $[1] !== t1 || $[2] !== t2) {
    t3 = <div className={styles.avatarShell}><AvatarStack items={curators} ltr={false} maxVisible={3} size={t1} column={t2} /></div>;
    $[0] = curators;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("overview_curators_heading");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <h2 className={styles.heading}>{t4}</h2>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("overview_curators_body");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <p className={styles.body}>{t6}</p>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== commonT) {
    t8 = commonT("learn_more");
    $[12] = commonT;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <Link asButton="secondary" size="small" href="/concierge">{t8}</Link>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t5 || $[17] !== t7 || $[18] !== t9) {
    t10 = <div className={styles.content}>{t5}{t7}{t9}</div>;
    $[16] = t5;
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t3) {
    t11 = <section className={styles.section}>{t3}{t10}</section>;
    $[20] = t10;
    $[21] = t3;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}